<template>
    <v-card>
        <v-card-title>{{ $t('choose_kanton') }}</v-card-title>
        <v-card-subtitle>In welchem Kanton steht Ihr Projekt?<br>Bitte wählen Sie:</v-card-subtitle>
        <v-card-text>
            <KantonRadio :model-value="kantonSelection" @update:model-value="onSelection" />
        </v-card-text>
        <v-card-actions>
            <v-btn
                color="action"
                variant="flat"
                :disabled="!kantonSelection"
                @click="$emit('next')"
                append-icon="fas fa-arrow-right"
            >
                {{ $t('next') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script setup lang="ts">
import KantonRadio from '@/components/kanton-radio.vue'
import { useKantonByKuerzel } from '@/composables/kanton'
import { useGlobals } from '@/helpers/globals'
import type { Kanton } from '@/models/Kanton'
import { onMounted, ref, type Ref } from 'vue'

const modelValue = defineModel<Kanton | null>()

const kantonSelection: Ref<string | null> = ref(null)

defineEmits<{
    (e: 'next'): void
}>()

onMounted(async () => {
    const globals = useGlobals()
    const k = await useKantonByKuerzel(globals.customer)
    if (k) {
        kantonSelection.value = k.kuerzel
        modelValue.value = k
    }
})

async function onSelection(value: string[] | string | null | undefined) {
    if (value && !Array.isArray(value)) {
        kantonSelection.value = value
        modelValue.value = await useKantonByKuerzel(value)
    }
}
</script>
